// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__269dr","col":"Table_col__3FdKi","fulfillmentStatus":"Table_fulfillmentStatus__VQ8nv","emailCol":"Table_emailCol__2wMtA"};